import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CodesParsed } from '../../interfaces/codes.types';

@Component({
  selector: 'app-form-control-text-editor',
  templateUrl: './form-control-text-editor.component.html',
  styleUrls: ['./form-control-text-editor.component.scss']
})
export class FormControlTextEditorComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() inputData: CodesParsed;

  constructor() { }

  ngOnInit() {
  }

}
